'use strict';

import {createHtmlElement} from "../../functions";

export class Switch {
  constructor(parent) {
    this.switch = createHtmlElement(parent, '', 'label', ['switch']);
    this.checkbox = createHtmlElement(this.switch, '', 'input', ['switch__checkbox']);
    this.slider = createHtmlElement(this.switch, '', 'span', ['switch__slider']);
    this.checkbox.type = 'checkbox';
    this.checkbox.checked = false;
  }

  set checked(value) {
    if (value === true || value === false)
      this.checkbox.checked = value;
  }

  set listener(value) {
    this.checkbox.addEventListener('change', value);
  }
}